import { observer } from 'mobx-react'

export const AttributeDisplayer = ({  store, extractor })  => {
    return extractor(store)
}

export default observer(AttributeDisplayer)